import React from 'react'
import News from '../../components/News'
import SearchNews from '../../components/SearchNews'
import SocialMediaLinks from '../../components/SocialMediaLinks'
import CustomImageComponent from '../../components/CustomImageComponent'

const NewsDetailsSec = (props) => {
    const { ourNewsSection, newsDetailSection } = props
    const tags = newsDetailSection?.blogDetails?.tags?.split(',') || [];

    return (
        <>
            <section className="details-slider-section mt-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 left-content ">
                            <div className="news-section news-page">
                                <div className="flex-card mb-5">
                                    <div className="img-block">
                                        <CustomImageComponent src={newsDetailSection?.blogDetails?.blogThumbnail} alt={newsDetailSection?.blogDetails?.title} className={"img-fluid w-100"} />
                                        <span className="date-text">
                                            {new Date(newsDetailSection?.blogDetails?.publishedDate).toLocaleString("default", {
                                                month: "long",
                                            }) +
                                                " " +
                                                new Date(newsDetailSection?.blogDetails?.publishedDate).getDate() +
                                                ", " +
                                                new Date(newsDetailSection?.blogDetails?.publishedDate).getFullYear()}
                                        </span>
                                    </div>
                                    <div className="content-block">
                                        <ul className="category-list">
                                            <li className="active">
                                                <CustomImageComponent src={"/assets/img/admin-icon.svg"} alt={newsDetailSection?.blogDetails?.author} className={"img-fluid"} />{newsDetailSection?.blogDetails?.author}
                                            </li>

                                        </ul>
                                        <div dangerouslySetInnerHTML={{ __html: `${newsDetailSection?.blogDetails?.content}` }} />
                                    </div>
                                </div>
                                <hr />
                                <div className="row align-items-center">
                                    <div className="col-md-6">
                                        <h4 className=" d-inline-block">Tags</h4>
                                        <div className="list-tag d-inline-block">
                                            {tags.length > 0 &&
                                                tags.map((item, index) => (
                                                    <span className="bg-light p-2 me-2 mb-1" key={index}>{item}</span>
                                                ))
                                            }
                                        </div>
                                    </div>
                                    <SocialMediaLinks></SocialMediaLinks>
                                </div>
                                <hr />
                            </div>
                        </div>
                        <div className="col-md-4 right-content">
                            <SearchNews data={newsDetailSection}></SearchNews>
                        </div>
                    </div>
                </div>
            </section>
            <News data={ourNewsSection || {}} />
        </>
    )
}

export default NewsDetailsSec